<template>
    <v-expand-transition>
        <div v-if="selectedChips?.length">
            <div>
                <div class="d-flex align-center ga-3 mb-2">
                    <span>{{ $t('eshop::group-filter.active') }}</span>
                    <v-btn
                        :prepend-icon="mdiClose"
                        color="orange"
                        variant="text"
                        class="text-body-1 h-auto"
                        @click="emit('cancelFilter')"
                    >
                        <span>{{ $t('eshop::group-filter.abort_all') }}</span>
                    </v-btn>
                </div>
                <div class="d-flex align-center flex-wrap ga-3 pb-2">
                    <v-chip
                        v-for="(chip, index) in selectedChips" :key="index"
                        class="rounded bg-white"
                    >
                        <div class="d-inline-flex align-center ga-1">
                            <span class="text-grey">{{ chip.title }}:</span>
                            <span class="font-weight-bold">{{ chip.value }}</span>
                        </div>
                        <template #append>
                            <button class="v-chip__close">
                                <v-icon
                                    :icon="mdiClose"
                                    size="x-small"
                                    @click="emit('removeFilter', chip.remove)"
                                ></v-icon>
                            </button>
                        </template>
                    </v-chip>
                </div>
            </div>
        </div>
    </v-expand-transition>
</template>

<script setup>
import { computed } from 'vue';
import { mdiClose } from '@mdi/js';
import { useFilterStore } from '../store/filter.js';
import pinia from '../../../plugins/pinia.js';

const props = defineProps({
    filter: Array,
});
const emit = defineEmits(['removeFilter', 'cancelFilter']);

const store = useFilterStore(pinia);

const selectedChips = computed(() => {
    const builder = [];
    const actualChanges = store.selected;
    for (let i = 0; i < actualChanges.length; i++) {
        if (actualChanges[i]) {
            if (props.filter?.[i] && props.filter?.[i]?.type !== 'number') {
                actualChanges[i].forEach(item => {
                    const found = props.filter[i].values.find(value => value.url === item);
                    if (found) {
                        builder.push({
                            title: props.filter[i].name,
                            value: found.name,
                            remove: {
                                index: i,
                                value: item,
                            },
                        });
                    }
                });
            } else if (props.filter?.[i] && 'slider' in props.filter?.[i]) {
                if (actualChanges[i][0] !== props.filter[i].slider.min || actualChanges[i][1] !== props.filter[i].slider.max) {
                    builder.push({
                        title: props.filter[i].name,
                        value: `${Math.floor(actualChanges[i][0])} - ${Math.round(actualChanges[i][1])}${props.filter[i].unit ? ' ' + props.filter[i].unit : ''}`,
                        remove: {
                            index: i,
                            default: [props.filter[i].slider.min, props.filter[i].slider.max],
                        },
                    });
                }
            }
        }
    }
    return builder;
});
</script>

<style scoped lang="scss">

</style>
